import React from "react";
import ServiceSection, { ServiceSectionProps } from "./base";
import { Typography } from "@mui/material";

const ServiceSectionIntroduction = (props: ServiceSectionProps) => {
  return (
    <ServiceSection service={props.service} headline={props.headline || `${props.service.name}のご紹介`}>
      {props.service.detail.introduction_section.contents.map((content: string, index: number) => {
        return (
          <Typography variant="body1" key={index}>{content}</Typography>
        )
      })}
    </ServiceSection>
  )
}

export default ServiceSectionIntroduction